/**
 * Weblab Tracker Dashboard Plugin — entry point and registration.
 *
 * Brings the standalone Weblab Tracker's read-only view page into FINN as a
 * dashboard submenu tab. Data comes from the hourly Athena snapshot in
 * weblab_tableau_prod.weblab_metrics_data_prod (see useWeblabTrackerData).
 *
 * Read-only: create/edit/review/admin stay in the standalone tracker.
 */

import React from "react";
import ScienceIcon from "@mui/icons-material/Science";
import type { DashboardPlugin } from "../../types";
import WeblabTrackerFilterPanel from "./WeblabTrackerFilterPanel";
import WeblabTrackerContent from "./WeblabTrackerContent";
import { useWeblabTrackerData } from "./useWeblabTrackerData";
import { WEBLAB_COLUMNS, formatWeblabValue } from "./weblabColumns";

export const weblabTrackerDashboard: DashboardPlugin = {
  id: "weblab-tracker",
  displayName: "Weblab Tracker",
  icon: React.createElement(ScienceIcon),
  description: "Read-only view of SPB weblab experiments and metrics",

  FilterPanel: WeblabTrackerFilterPanel,
  ReportContent: WeblabTrackerContent,
  useData: useWeblabTrackerData,

  // No AI summary and no second-table comparison for the tracker view.
  supportsComparison: false,

  exportCsv: (data: any) => {
    const rows = data?.rows ?? [];
    if (rows.length === 0) return "";
    const cols = WEBLAB_COLUMNS;
    const header = cols.map((c) => `"${c.header}"`).join(",");
    const lines = rows.map((row: any) =>
      cols
        .map((c) => {
          const v = formatWeblabValue(row[c.field as string], c.format);
          return `"${String(v).replace(/"/g, '""')}"`;
        })
        .join(",")
    );
    return [header, ...lines].join("\n");
  },
};
